import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { AudioRecordingRepository } from "@/domains/dexie-db/repositories/audio-recording/audio-recording";
import { LocalAudioRecordingBlobsRepository } from "@/domains/dexie-db/repositories/audio-recording/local-audio-recording-blobs";
import { LocalAudioRecordingTranscriptTurnsRepository } from "@/domains/dexie-db/repositories/audio-recording/local-audio-recording-transcript-turns";
import { makeObservable } from "mobx";

export class AppStoreDexieRepositoryStore extends AppSubStore {
  constructor(injectedDeps: AppSubStoreArgs) {
    super(injectedDeps);

    makeObservable(this, {
      audioRecordings: true,
      localAudioRecordingBlobs: true,
      localAudioRecordingTranscriptTurns: true,
    });
  }

  get localAudioRecordingBlobs() {
    return new LocalAudioRecordingBlobsRepository({
      tableRef: () => this.store.memDb.table("localAudioRecordingBlobs"),
    });
  }

  get localAudioRecordingTranscriptTurns() {
    return new LocalAudioRecordingTranscriptTurnsRepository({
      tableRef: () => this.store.memDb.table("localAudioRecordingTranscriptTurns"),
    });
  }

  get audioRecordings() {
    return new AudioRecordingRepository({
      store: this.store,
      repositories: {
        localAudioRecordingBlobs: this.localAudioRecordingBlobs,
        localAudioRecordingTranscriptTurns: this.localAudioRecordingTranscriptTurns,
      },
    });
  }
}
